import { useEffect, useState } from "react";
import { ArrowRight, List, X } from "@phosphor-icons/react";

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  const [compact, setCompact] = useState(false);
  const close = () => setOpen(false);

  useEffect(() => {
    const handleScroll = () => setCompact(window.scrollY > 90);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogoClick = () => {
    close();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <header className={`nav-wrap ${compact ? "compact" : ""}`} data-testid="site-navigation">
      <a className="brand" href="#top" data-testid="navigation-home-link" onClick={handleLogoClick}>
        <img
          src="https://customer-assets-39nsmqrw.emergentagent.net/job_page-builder-840/artifacts/j7s2mihp_004_GulfCoastFleeting_logo_white_PNG.png"
          alt="Gulf Coast Fleeting"
          data-testid="navigation-company-logo"
        />
      </a>
      <nav className={open ? "nav-links open" : "nav-links"} aria-label="Main navigation">
        <a href="#services" data-testid="navigation-services-link" onClick={close}>Services</a>
        <a href="#safety" data-testid="navigation-safety-link" onClick={close}>Safety</a>
        <a href="#location" data-testid="navigation-location-link" onClick={close}>Our Coast</a>
        <a href="#faq" data-testid="navigation-faq-link" onClick={close}>FAQ</a>
      </nav>
      <a className="nav-cta" href="#contact" data-testid="navigation-quote-link">
        Request quote <ArrowRight size={17} weight="bold" />
      </a>
      <button
        className="menu-button"
        type="button"
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        data-testid="navigation-menu-button"
        onClick={() => setOpen(!open)}
      >
        {open ? <X size={24} weight="bold" /> : <List size={24} weight="bold" />}
      </button>
    </header>
  );
};